import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Notification, NotificationData } from '@Types/api/notifications';

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: {
    messages: [] as Notification[],
  },
  reducers: {
    addMessage: (state, action: PayloadAction<NotificationData>) => {
      if (state.messages.length > 0) {
        const firstMessage = state.messages[0];

        if (
          firstMessage?.data.requestId === action.payload.requestId &&
          firstMessage?.data.newStatus === action.payload.newStatus
        ) {
          return;
        }
      }

      state.messages.unshift({
        isRead: false,
        data: action.payload,
        receivedTime: new Date(),
      });
    },
    readMessage: (state, action: PayloadAction<number>) => {
      state.messages[action.payload].isRead = true;
    },
    markAllAsRead: (state) => {
      state.messages.forEach((message) => {
        message.isRead = true;
      });
    },
  },
});

export const { addMessage, readMessage, markAllAsRead } =
  notificationsSlice.actions;

export default notificationsSlice;
